/**
 * Items for the navigation bar
 * @type {Array}
 * @constant
 * @dev This constant is used to render the navigation bar
 * @author Jesús Sánchez Fernández
 */
export const NAV_ITEMS = [
    {
        label: 'How to play',
        href: 'https://mythicalbeings.io/how-to-play.html',
    },
    {
        label: 'Whitepaper',
        href: 'https://mythical-beings.gitbook.io/whitepaper',
    },
    {
        label: 'About',
        href: 'https://mythicalbeings.io/',
    },
];
